import script from "./left-slider.vue?vue&type=script&lang=ts&setup=true"
export * from "./left-slider.vue?vue&type=script&lang=ts&setup=true"

import "./left-slider.vue?vue&type=style&index=0&id=d49ca4c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d49ca4c4"]])

export default __exports__